import { render, staticRenderFns } from "./_BroadcastOverridesMessage.vue?vue&type=template&id=5d93077b&scoped=true&"
import script from "./_BroadcastOverridesMessage.vue?vue&type=script&lang=js&"
export * from "./_BroadcastOverridesMessage.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastOverridesMessage.vue?vue&type=style&index=0&id=5d93077b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93077b",
  null
  
)

export default component.exports